export default {
  // labels
  'label.register_title1': 'Зарегистрироваться',
  'label.register_title2': 'Совершайте платежи и переводы',
  'label.register_title3': 'Управляйте избранным',
  'label.register_description1': 'Зарегистрируйтесь, просто указав номер телефона, и осуществляйте безкомиссионные платежи.',
  'label.register_description2': '17 категориях совершайте платежи по более чем 1000 услугам, также воспользуйтесь переводами с номером и картой.',
  'label.register_description3': 'Улучшайте выбранные платежи, управляйте автоматическими платежами и долгами, используйте NFC-сервисы в свою пользу.',
  'label.auth.least_symbol': 'Минимум 8 символов',
  'label.auth.most_symbol': 'Максимум 30 символов',
  'label.auth.min_max_symbols': 'Минимум 8, максимум 30 символов',
  'label.auth.uppercase': 'Минимум 1 заглавная буква',
  'label.auth.lowercase': 'Строчные буквы',
  'label.auth.number': 'Минимум 1 цифра',
  'label.auth.character': '1 специальный символ: (@=$%)(#^&)]]',
  'label.register_error.whitespace': 'Не оставляйте пустым',
  'label.register_error.match': 'Пароль не соответствует',
  'label.login_title': 'Быстро, надежно, {easy}',
  'label.login_title.emanat': 'Быстро, надежно и  {easy}',
  'label.cobrand.alert': 'Чтобы завершить заказ карты MPAY, ты должен подтвердить свою личность с помощью SIMA {sima}.',
  'label.login_description': 'Войдите или зарегистрируйтесь, чтобы проводить платежи и переводы для тысяч сервисов за считанные секунды.',
  'label.login_description_new': 'Совершай платежи и переводы для множества услуг быстро, легко и безопасно.',
  'label.phone_number': 'Номер телефона',
  'label.password': 'Пароль',
  'label.old_password': 'Предыдущий пароль',
  'label.new_password': 'Новый пароль',
  'label.confirm_password': 'Подтвердите пароль',
  'label.remember': 'Запомнить',
  'label.dashboard': 'Панель индикаторов',
  'label.favorites.added': 'Добавлено в избранное',
  'label.favorites.added.desc': 'Платеж успешно добавлен в избранное. Вы можете просмотреть все избранные элементы в правой панели.',
  'label.favorites': 'Избранные',
  'label.favorites.search': 'Поиск в Избранных',
  'label.favorites.card': 'Вы находитесь в Избранных!',
  'label.autoPayment.card': 'Вы находитесь в автоплатежах!',
  'label.favorites.description': 'Создавайте Избранные операции, оплачивайте и переводите быстрее.',
  'label.autoPayment.description': 'Создав автоматические платежи, вы можете осуществлять оплату автоматически и без задержек.',
  'label.favorites.not_found.title': 'Избранных операций не найдено.',
  'label.favorites.not_found.description': 'Создавайте Избранные операции, оплачивайте и переводите быстрее.',
  'label.favorites.delete.description': 'Когда вы удаляете избранное, связанные с ним автоплатежи также будут удалены.',
  'label.automobiles.delete.description': 'Автомобиль с номером {automobile} будет удален',

  'label.switch.heading': 'Кто-то вошел в ваш аккаунт',
  'label.switch.description': 'Если это не вы, выберите один из следующих вариантов в целях безопасности.',
  'label.payment_info': 'Платежная информация',

  'label.autopayment': 'Автоплатежи',
  'label.autopayment.new': 'Новый',
  'label.autopayment.empty': 'Автоматических платежей не обнаружено.',
  'label.autopayment.search.empty': 'Нет автоматических платежей по вашему запросу.',
  'label.autopayment.create': 'Создать автоплатеж',
  'label.autopayment.choose.favorite': 'Mövcud seçilmişlərdən seç',
  'label.autopayment.monthly': 'Ежемесячно',
  'label.autopayment.debt': 'по задолженности',
  'label.autopayment.schedule': 'согласно графику',
  'label.autopayment.once': 'Один раз',

  'label.limits': 'Лимиты',

  'label.faq.title': 'Как мы можем вам помочь?',
  'label.faq.contact.title': 'Контактная ссылка',
  'label.faq.address': 'ул. Альберта Агарунова. 7Б, AZ1075 Баку, Азербайджан',

  'label.add.favorite': 'Добавить в избранное',
  'label.added.favorite': 'Добавлено в избранное',
  'label.added.description': 'Избранное успешно создано. Вы можете просмотреть избранное из списка.',
  'label.new.favorite': 'Новое избранное',
  'label.new.payment': 'Новый платеж',
  'label.choose.operation': 'Выберите оплату',
  'label.choose_from_list': 'Выберите из списка',
  'label.create.favorite': 'Создать избранное',
  'label.new.create.favorite': 'Добавить',
  'label.history.subTitle': 'Терминальный платеж',
  'label.info.popup.title': 'Информация о карте',
  'label.requisite.popup.title': 'Реквизиты счета',
  'label.cobrand.history.title': 'История карты MPAY',
  'label.my.cards': 'Мои карты',
  'label.cards': 'Карты',
  'label.card.order': 'Заказ карты',
  'label.card.order.success.title': 'Карта заказана',
  'label.card.order.success.desc': 'Пожалуйста, принесите с собой удостоверение личности, когда придете в отделение.',
  'label.saved.cards': 'Мои сохраненные карты',
  'label.card.order.title': 'Заказ карты MPAY',
  'label.card.order.detail.title': 'Оплачивайте вовремя, на этот раз картой!',
  'label.card.order.desc': 'Мы продолжаем облегчать безналичные платежи. Получите свою карту MPAY бесплатно сейчас и производите платежи быстро и',
  'label.card.order.detail.desc': 'Мы продолжаем упрощать процесс оплаты с помощью карты MPAY. Закажите сейчас для безопасных платежей и множества преимуществ.',
  'label.panels.header1': 'Как получить карту?',
  'label.panels.header2': 'Как пополнить баланс карты?',
  'label.panels.header3': 'Как установить или сменить ПИН-код?',
  'label.panels.header4': 'Каков годовой доход на остаток счета карты?',
  'label.panels.content1': 'Вы можете заказать карту онлайн. После заказа вы получите информацию о процессе подготовки карты по SMS. Когда она будет готова, вы сможете забрать её в выбранном вами отделении.',
  'label.panels.content2': 'Пополнить баланс карты можно через платежные терминалы.',
  'label.panels.content3': 'Вы можете установить или изменить ПИН-код через приложение "MPAY".',
  'label.panels.content4': 'Годовой баланс на счете карты установлен на уровне X%.',
  'label.advantages.title1': 'Бесплатное снятие наличных',
  'label.advantages.title2': 'Бесплатные переводы с карты на карту',
  'label.advantages.title3': 'Бесплатная установка и смена PIN-кода',
  'label.advantages.title4': 'Платное пополнение карты',
  'label.advantages.title5': 'Уведомления через приложение и SMS',
  'label.advantages.title6': 'X% годового дохода на остаток счета карты в AZN',
  'label.advantages.desc1': 'Вы можете воспользоваться бесплатным снятием наличных 5 раз в месяц во всех банкоматах страны.',
  'label.advantages.desc2': 'Вы можете переводить между картами MPAY. Комиссия 0,5% применяется к переводам на карты отечественных банков.',
  'label.advantages.desc3': 'You can set and change a new PIN easily and free of charge in the MPAY app.',
  'label.advantages.desc4': 'Вы можете пополнить свой счет через терминалы, а также из кошелька MPAY без дополнительных комиссий.',
  'label.advantages.desc5': 'Наслаждайтесь преимуществом отслеживания транзакций через приложение и получения уведомлений по SMS.',
  'label.advantages.desc6': 'Сумма начисленных процентов за месяц будет переведена на счет карты в последний рабочий день каждого месяца.',
  'label.card.tabLink1': 'О карте',
  'label.card.tabLink2': 'Преимущества',
  'label.card.tabLink3': 'Подробнее',
  'label.card.type': 'Тип карты',
  'label.order.date': 'Архив заказов',
  'label.status': 'Статус',
  'label.cobrand.settings.title': 'Параметры карты MPAY',
  'label.cardholder.name': 'Имя держателя карты',
  'label.card.number': 'Номер карты',
  'label.expiry.date': 'Срок действия',
  'label.card.info.popup.desc': 'Эта карта - совместный продукт MPAY и Рабита Банка.',
  'label.rename.title': 'Переименовать',
  'label.my.mpay.card': 'Моя карта MPAY',
  'label.mpay.card': 'Карта MPAY',
  'label.recipient.name': 'Имя получателя',
  'label.buyer.account': 'Аккаунт получателя',
  'label.receiving.bank': 'Банк-получатель',
  'label.swift': 'SWIFT',
  'label.vöen': 'ИНН',
  'label.bank.code': 'Код банка',
  'label.reporter.account': 'Корреспондентский счет',
  'label.blocked': 'Карта заблокирована',
  'label.block.card.title': 'Заблокировать карту',
  'label.block.card.desc': 'Если ты заблокируешь карту, с ней невозможно будет совершать операции. Ты можешь разблокировать карту в любое время.',
  'label.unblock.card.title': 'Разблокировать карту',
  'label.unblock.card.desc': 'После разблокировки карты ты сможешь снова выполнять операции.',
  'label.reset.pin.title': 'Сбросить попытки ввода ПИН-кода',
  'label.reset.pin.desc': 'Получить еще 3 попытки.',
  'label.transfer.amount': 'Сумма перевода',
  'label.transfer.source': 'Источник перевода',
  'label.phone.number': 'Мобильный номер',
  'label.branch.delivery': 'Отделение для доставки',
  'label.secret.word': 'Секретное слово',
  'label.card.order.status': 'У вас заказана карта MPAY.',
  'label.pin.code': 'PIN-код',
  'label.fill.information.order': 'Заполните информацию для заказа',
  'label.card.benefits': 'Преимущества карты',
  'label.how.get.card': 'Как я могу получить карту?',
  'label.fill.form': 'Заполните форму',
  'label.follow.notification': 'Следуйте уведомлению по SMS',
  'label.get.card': 'Получите карту',
  'label.annual.service.fee': 'Годовая плата',
  'label.free': '0 AZN',
  'label.duration': 'Срок',
  'label.years': '5 лет',
  'label.currency': 'Валюта',
  'label.cashback': 'Кэшбэк',
  'label.percent': 'до 40%',

  'label.payments': 'Платежи',
  'label.transfers': 'Переводы',
  'label.transfer': 'Перевод',
  'label.coupons': 'Мои купоны',
  'label.debts': 'Мои долги',
  'label.transfers.wallet': 'Перевод на кошелек',
  'label.top-up': 'Пополнение баланса',
  'label.card_transfer': 'Перевод с карты',
  'label.wallet_transfer': 'Перевод с кошелька',
  'label.payment_source': 'Источник оплаты',
  'label.payment_amount': 'Сумма платежа',
  'label.target_card': 'Целевая карта',
  'label.share.receipt': 'Поделитесь квитанцией',
  'label.call.center.title': 'Нажмите для контактов',
  'label.personal_info': 'Персональные данные',
  'label.change_password': 'Смена пароля',
  'label.select_language': 'Выбор языка',
  'label.notifications': 'Уведомления',
  'label.terms_conditions': 'Правила и условия',
  'label.read_all': 'Отметить как прочитанные',
  'label.name_surname': 'Имя, Фамилия',
  'label.name': 'Имя',
  'label.surname': 'Фамилия',
  'label.father_name': 'Отчество',
  'label.full_name': 'Имя, Фамилия, Отчество',
  'label.pin': 'ПИН',
  'label.date_of_birth': 'Дата рождения',
  'label.gender': 'Пол',
  'label.language': 'Язык',
  'label.settings': 'Настройки',
  'label.history': 'История',
  'label.automobiles': 'Автомобили',
  'label.support': 'Поддержка',
  'label.wallet': 'Кошелек',
  'label.old.wallet': 'Предыдущий аккаунт',
  'label.old.balance': 'Предыдущий баланс MPAY',
  'label.card': 'Карта',
  'label.terminal': 'Терминал',
  'label.last_operations': 'Последние операции',
  'label.frequently_used': 'Часто используемые',
  'label.categories': 'Категории',
  'label.no_comission': 'Без комиссии',
  'label.comission': 'К этой сумме будет добавлена комиссия {amount} AZN',
  'label.receipt.failed.operation': 'Ошибка операции',
  'label.receipt.failed.payment': 'Неудачное платеж',
  'label.receipt.failed.transfer': 'Неудачный перевод',
  'label.receipt.inprogress.payment': 'Платеж в процессе',
  'label.receipt.inprogress.transfer': 'Перевод в процессе',
  'label.transfer.receipt.success': 'Перевод выполнен',
  'label.transfer_target.receipt.success': 'Перевод принят',
  'label.general.receipt.success': 'Платеж завершен',
  'label.success': 'Успешно',
  'label.success.card.name': 'Название карты успешно изменено.',
  'label.success.card.delete': 'Данные карты больше не доступны.',
  'label.pending': 'В процессе',
  'label.fail': 'Неудачно',
  'label.approved': 'Утверждено',
  'label.receipt': 'Квитанция',
  'label.other_operators': 'Другие Oператоры',
  'label.mno': 'Добавить номер',
  'label.pay_with_new_card': 'Оплатить новой картой',
  'label.saved_cards': 'Сохраненные карты',
  'label.service.debt.amount': 'Задолженность по {serviceName}:',
  'label.service.balance.amount': 'Баланс {serviceName}:',
  'label.switch.success_logout': 'Вышли из',
  'label.coupon.coming': 'Подарочная сумма получена',
  'label.coupon.sent': 'Подарочная сумма отправлена',
  'label.coupon.sender.gift': 'Отправитель подарка',
  'label.coupon.pending.title': 'Подарочная сумма в ожидании',
  'label.coupon.pending.status': 'Ожидается',
  'label.coupon.accepted.title': 'Подарочная сумма получена',
  'label.coupon.accepted.status': 'Получена',
  'label.coupon.rejected.title': 'Подарочная сумма отклонена',
  'label.coupon.rejected.status': 'Отклонена',
  'label.coupon.reversed.title': 'Подарочная сумма возвращена',
  'label.coupon.reversed.status': 'Возвращён',
  'label.coupon.ready.title': 'Подарочная сумма переведена.',
  'label.coupon.ready.status': 'Переведена',
  'label.coupon': 'Купон',
  'label.fav.filter': 'Фильтр Избранное',
  'label.fav.ad_new': 'Добавить новый Избранное',
  'label.automobile.add_new': 'Добавьте новый номер транспортного средства',
  'label.fav.suggest.heading': 'Давайте добавим их в Избранные.',
  'label.fav.suggest.desc': 'Добавьте в Избранные, чтобы всегда получать информацию о задолженностях.',
  'label.automobiles.desc': 'Управляйте регистрационными номерами транспортных средств здесь, чтобы легко оплачивать парковку через "Parqour"',
  'label.send.money': 'Pul göndər',
  'label.mpay.download': 'Скачать MPAY',
  'label.mpay.downoad.desc': 'Через камеру телефона сканируй QR-код и скачай',
  'label.change.pin.title': 'Изменит PIN-код',
  'label.change.pin.new': 'Новый PIN-код',
  'label.change.pin.new.reenter': 'Новый PIN-код еще раз',
  'label.deposit.deactivate.title': 'Деактивировать ставку по депозиту',
  'label.deposit.deactivate.desc': 'Если отключено, ежемесячная процентная ставка по депозиту не будет начисляться на карту',
  'label.deposit.activate.title': 'Активировать процентную ставку по депозиту',
  'label.deposit.activate.desc': 'Если активировано, ежемесячная процентная ставка по депозиту будет начисляться на карту',
  'label.transition.source': 'переходный источник',
  // actions
  'action.forgot_password': 'Забыли пароль?',
  'action.sign_in': 'Войти',
  'action.sign_up': 'Зарегистрироваться',
  'action.send_again': 'Отправить снова',
  'action.confirm': 'Подтвердить',
  'action.reset_password': 'Сбросить пароль',
  'action.continue': 'Продолжить',
  'action.add_phone_number': 'Добавить новый номер',
  'action.back_to_login': 'Назад к входу',
  'action.top_up': 'Пополнение баланса',
  'action.top_up.wallet': 'Пополнение баланса',
  'action.top_up.balance': 'Пополнение баланса',
  'action.wallet_transfer': 'Перевод',
  'action.transfer_to_wallet': 'Перевод',
  'action.repeat': 'Заплатите еще раз',
  'action.add_favorite': 'Добавить в избранное',
  'action.added_favorite': 'Добавлено в избранное',
  'action.share': 'Поделиться',
  'action.download': 'Скачать',
  'action.mpay.download': 'Нажмите здесь, чтобы скачать',
  'action.look.receipt': 'Посмотреть чек',
  'action.transfer.wallet': 'Перевести на кошелек',
  'action.call.center': 'Связаться со службой поддержки',
  'action.all': 'Все',
  'action.success': 'Успешный',
  'action.failed': 'Неудачный',
  'action.in_progress': 'В ожидании',
  'action.edit_label': 'Переименовать',
  'action.edit': 'Редактировать',
  'action.delete': 'Удалить',
  'action.delete.question': 'Вы уверены, что хотите удалить из избранного?',
  'action.delete.automobile': 'Вы уверены в удалении транспортного средства?',
  'action.logout': 'Ты уверен(а), что хочешь выйти?',
  'action.fav.pay_debts': 'Оплатить долги',
  'action.fav.pay_all_debts': 'Оплатить все долги',
  'action.delete.autopay': 'Удалить автоплатеж',
  'action.delete.autopay_desc': 'Вы уверены, что хотите удалить автоплатеж пользователя {autoPayName}?',
  'action.search.cancel': 'Отмена',
  'action.switch.logout': 'Выйти из других аккаунтов',
  'action.switch.changePasword': 'Измените свой пароль',
  'action.fav.pay_all_debts_title': 'Для оплаты не хватает {amount} AZN',
  'action.fav.pay_all_debts_desc': 'Текущий баланс {amount}. Пополни баланс и заверши платеж! 🥳',
  'action.pay': 'Оплатить',
  'action.personal_info': 'Персональные данные',
  'action.change_password': 'Изменить пароль',
  'action.select_language': 'Выберите язык',
  'action.notifications': 'Уведомления',
  'action.sign_out': 'Выход',
  'action.update_info': 'Обновить информацию',
  'action.back': 'Назад',
  'action.cancel': 'Отмена',
  'action.remove': 'Удалить',
  'action.card.remove': 'Удалить карту',
  'action.save': 'Сохранить',
  'action.do_operation': 'Сделать операцию',
  'action.change': 'Изменять',
  'action.close': 'Закрывать',
  'action.go_dashboard': 'На главную',
  'action.go_automobiles': 'Вернуться к списку автомобилей',
  'action.home': 'Главная',
  'action.favorites': 'Избранное',
  'action.card.order': 'Заказать',
  'action.more.detail': 'Подробнее',
  'action.search.autopayment': 'Искать в автоплатежах',
  'action.rename': 'Переименовать карту',
  'action.account.requisites': 'Детали учетной записи',
  'action.change.pin': 'Изменить ПИН-код',
  'action.reset.pin': 'Сбросить попытки ввода ПИН',
  'action.set.limits': 'Установить лимиты',
  'action.deposit.interest': 'Процент по депозиту',
  'action.send.money': 'Отправить деньги',
  'action.block': 'Блокировать',
  'action.more': 'Больше',
  'action.soon': 'Скоро...',
  'action.extract': 'Экспортировать',
  'action.try': 'Получить',
  'action.return_automobiles_list': 'Вернуться к списку',
  'action.unblock': 'Разблокировать',
  'action.add.favorites': 'Добавить в избранное',
  'action.order.confirm': 'Подтвердить заказ',
  'action.look_history': 'Посмотреть историю',
  'action.new_automobile': 'Новый автомобиль',
  'action.add_new_automobile': 'Добавить новый автомобиль',
  'action.deposit.deactivate': 'Деактивировать',
  'action.deposit.activate': 'Активировать',
  'action.limits.table': 'Таблица лимитов',
  'action.limits.increase': 'Увеличь лимит',

  // filters
  'filters.action': 'Filter',
  'filters.period.this_week': 'Последняя 1 неделя',
  'filters.period.last_month': 'Последние 30 дней',
  'filters.period.last_months': 'Последние 90 дней',
  'filters.date': 'Дата',
  'filters.date.title': 'Выберите дату',
  'filters.transaction.types': 'Тип операции',
  'filters.coupons.types': 'Тип купона',
  'filters.transaction.types.top_up': 'Пополнение баланса',
  'filters.transaction.types.transfer': 'Перевод',
  'filters.transaction.types.balance-payment': 'Оплатить через кошелек',
  'filters.transaction.types.card-payment': 'Оплатить картой',
  'filters.transaction.types.qr_terminal': 'Терминальная транзакция',
  'filters.coupon.types.received': 'Полученные',
  'filters.coupon.types.sent': 'Отправленные',
  'filters.transfers': 'Переводы',
  'filter.category': 'Категория',
  // entities

  // validations
  'validation.self_transfer': 'Невозможно отправить деньги на тот же счет.',
  'validation.sercive_disabled': 'Сервис недоступен.',
  'validation.required': 'Это поле не может быть пустым.',
  'validation.number': 'Введите правильный номер.',
  'validation.pattern': 'Введенная информация не соответствует шаблону.',
  'validation.maxlength': 'Превышен требуемый максимальный лимит ({maxlength}).',
  'validation.minlength': 'Не выполняется требуемый минимальный лимит ({minlength}).',
  'validation.min': 'Минимум-({min}) AZN',
  'validation.max': 'Максимум-({max}) AZN',
  'validation.amount': 'Введите правильную сумму.',
  'validation.error.not-enough-ballance': 'Недостаточный баланс.',
  'validation.card.number.invalid': 'Введите действительный номер карты.',
  'validation.card.not.support': 'Переводы возможны только на указанные карты.',
  'validation.contains_digits': 'Хотя бы 1 цифра (0-9)',
  'validation.contains_lower_letters': 'Хотя бы 1 строчная буква',
  'validation.contains_upper_letters': 'Хотя бы 1 заглавная буква',
  'validation.special_symbols': 'Хотя бы 1 специальный символ',
  'validation.password_format': 'Пароль не соответствует требованиям.',
  'validation.password_mismatch': 'Пароли не совпадают.',
  'server.error.internal': 'Внутренняя ошибка сервера',
  // pages

  // misc
  'misc.auth.sign_in.title': 'Войти',
  'misc.auth.reset.title': 'Сбросить пароль',
  'misc.auth.set_new_password.title': 'Установить новый пароль',
  'misc.auth.without_account': 'Нет учетной записи?',
  'misc.auth.login.number': 'Войти в аккаунт по номеру',
  'misc.auth.sign.app': 'Зарегистрируйся через приложение',
  'misc.auth.with_account': 'Есть аккаунт?',
  'misc.auth.without_otp_code': 'Не получили OTP-код?',
  'misc.auth.retry.qr': 'Нажми, чтобы обновить QR-код',
  'misc.auth.account.complete.registration': 'Нет аккаунта? Заверши регистрацию через приложение:',
  'misc.auth.account.complete.register': 'Зарегистрируйся в приложении через QR-код',
  'misc.auth.open.camera': 'Открой камеру на телефоне.',
  'misc.auth.scan.qr': 'Сканируй QR-код.',
  'misc.auth.download.app': 'Установи мобильное приложение или зарегистрируйся сразу.',
  'misc.auth.scan.qr.register': '2. Отсканируй QR-код с телефона.',
  'misc.auth.download.app.register': '3. Скачай мобильное приложение “MPAY”.',
  'misc.auth.account.login.qr_code': 'Вход по QR-коду',
  'misc.auth.account.login.open_app': 'Запусти “MPAY”.',
  'misc.auth.account.login.enter_scan': 'Перейди в раздел сканирования.',
  'misc.auth.account.login.scan_to_login': 'Наведи и готово!',
  'misc.auth.create.title': 'Создай аккаунт в приложении MPAY.',
  'misc.auth.download.app.modal': 'Скачай приложение MPAY.',
  'misc.auth.download.signUp': 'Войди в приложение и зарегистрируйся.',
  'misc.auth.using.services': 'Активируй аккаунт и начни пользоваться услугами MPAY.',
  'misc.common.or': 'Или',
  'misc.common.or.uppercase': 'Или',
  'misc.common.more': 'Более',
  'misc.common.easy': 'Удобно',
  'misc.common.sima': 'в мобильном приложении MPAY',
  'misc.auth.sign_up.title': 'Зарегистрироваться',
  'misc.auth.sign_up.agreement': 'Регистрируясь, вы соглашаетесь с {0} и {1}.',
  'misc.auth.sign_up.agreement.terms': 'Условия использования, правила.',
  'misc.auth.sign_up.agreement.privacy': 'Политика конфиденциальности',
  'misc.auth.otp.confirm.title': 'Введите код',
  'misc.auth.otp.label': 'Пожалуйста, введите <strong>шестизначный код</strong>, отправленный на <strong>{phone}</strong>."',
  'misc.auth.asan.label.select_number': 'Выберите номер для продолжения',
  'misc.suggest.header': '{category} ödənişin tamamlandı',
  'misc.suggest.desc': 'Digər {category} əməliyyatlarının aparılması üçün “{category}” kateqoriyasına keç.',

  'misc.settings.campaigns.title': 'О услугах',
  'misc.settings.campaigns.content': 'Получайте уведомления о акциях и услугах',
  'misc.settings.debt.title': 'Платежи по долгам',
  'misc.settings.debt.content': 'Получайте предварительное уведомление о предстоящем платеже',
  'misc.settings.password.info': 'Новый пароль должен содержать не менее 8 символов и включать хотя бы 1 прописную букву, строчные буквы и цифры.',
  'misc.settings.notifications.info': 'Вы можете выбрать тип уведомления, который вы хотите.',
  'misc.settings.notifications.type.app': 'Приложение',
  'misc.settings.notifications.type.email': 'Почта',
  'misc.settings.notifications.type.email.address': 'Адрес электронной почты',
  'misc.settings.notifications.type.sms': 'СМС',
  'misc.settings.notifications.empty': 'Уведомлений нет. Продолжайте изучать!',
  'misc.settings.gender.male': 'Мужской',
  'misc.settings.gender.female': 'Женский',
  'misc.settings.language.az': 'Азербайджанский',
  'misc.settings.language.eng': 'Английский',
  'misc.settings.language.ru': 'Русский',
  'misc.settings.terms_conditions.terms.title': 'User Terms',
  'misc.settings.terms_conditions.privacy.title': 'Политика конфиденциальности',
  'misc.settings.terms_conditions.tariffs.title': 'Тарифы',
  'misc.settings.profile.personal': 'Персональные данные',
  'misc.settings.profile.password': 'Изменить пароль',
  'misc.settings.profile.language': 'Выбрать язык',
  'misc.settings.profile.notification': 'Уведомления',
  'misc.settings.profile.terms_conditions': 'Правила и условия',
  'misc.settings.profile.logout': 'Выйти',
  'misc.settings.profile.password-warning': 'Новый пароль должен содержать не менее 8 символов и включать хотя бы 1 прописную букву, строчные буквы и цифры.',
  'misc.saved.remove.desc': 'Все данные этой карты будут удалены.',
  'misc.saved.remove.title': 'Удалить карту?',
  'misc.saved.update.title': 'Изменить имя',
  'misc.card.update.title': 'Изменить название карты',
  'misc.saved.update.info': 'Обновить информацию',
  'misc.saved.add.title': 'Установить имя',
  'misc.saved.index.empty': 'Карта не найдена.',
  'misc.support.search.empty': 'По Вашему запросу результатов не найдено',
  'misc.history.automobile.empty': 'Нет доступных транспортных средств.',
  'misc.history.index.empty': 'Никаких операций не найдено',
  'misc.coupon.index.empty': 'Купон не найден.',
  'misc.history.search.empty': 'Операции, соответствующие вашему запросу, не найдены',
  'misc.coupon.search.empty': 'Купон не найден для вашего запроса.',
  'misc.history.day.yesterday': 'Вчера',
  'misc.history.day.today': 'Сегодня',

  'misc.category.search.placeholder': 'Введите название сервиса',
  'misc.category.search.no_results': 'Сервис, соответствующий вашему запросу, не найден',

  'misc.fav.remove.title': 'Удалить избранное',
  'misc.fav.index.empty': 'Избранное, соответствующее вашему запросу, не найдено',
  'misc.fav.search.placeholder': 'Поиск',
  'misc.fav.input.placeholder': 'Название',
  'misc.fav.debt.last_update': 'Долги обновлены:',
  'misc.fav.debt.request': 'Запрос долга',
  'misc.fav.debt.request.warning_message': 'Запрос на задолженность можно проводить один раз в 1 час.',
  'misc.fav.total_amount.title': 'Общая сумма:',
  'misc.fav.debt_payment.title': 'Оплата задолженности',
  'misc.fav.debt_payment_approve': 'Подтверждение платежа',
  'misc.fav.debt_payment_category': 'Избранные/Долги',
  'misc.fav.debt.payment.date': 'Дата операции',
  'misc.fav.debt.payment.category': 'Услуга',
  'misc.fav.debt.payment.amount': 'Сумма',
  'misc.fav.debt.payment.commission': 'Комиссия',
  'misc.fav.debt.payment.totalAmount': 'Общая сумма',
  'misc.fav.debt.payment.source': 'Источник',
  'misc.fav.autopayment.label': 'Производите оплату автоматически',
  'misc.fav.inactive.title': 'Сервис временно не работает',
  'misc.fav.inactive.description': 'Попробуй еще раз, когда он будет активен',
  'misc.autopayment.frequency': 'Ödəniş tezliyi',
  'misc.autopayment.last.PaymentDate': 'Son ödəniş tarixi',
  'misc.limits.monthly.error': 'Оставшийся лимит (ежемесячный): {amount}.',
  'misc.limits.daily.error': 'Оставшийся лимит (ежедневный): {amount}.',
  'misc.limits.description': 'Для возможности совершать больше платежей и переводов необходимо сначала пройти идентификацию. После этого ваш лимит будет увеличен.',
  'misc.limits.verified.description': 'Теперь ты можешь совершать больше переводов и платежей, потому что мы тебе верим. 💙',
  'misc.limits.procedures': 'Эти процедуры соблюдаются согласно закону «О платежных услугах и платёжных системах».',
  'misc.limits.warning.info': 'Таблица лимитов применяется только к идентифицированным пользователям.',
  'misc.limits.verified.warning.info': 'Ты можешь просмотреть увеличенные лимиты через таблицу лимитов.',
  'misc.limits.PAYMENT.title': 'Месячный лимит на платежи',
  'misc.limits.TOP_UP.title': 'Месячный лимит кошелька',
  'misc.limits.PAYMENT.limit.tooltip': 'Данный лимит распространяется на операции, совершаемые как с использованием кошелька, так и карты.',
  'misc.limits.TOP_UP.limit.tooltip': 'Данный лимит применяется к суммам, зачисленным через кошелёк и карту.',
  'misc.limits.will_update': 'Будет обновлено:',
  'misc.limits.identification': 'Завершите идентификацию, чтобы увеличить лимиты',

  'misc.transfer.add_to_fav.title': 'Добавить в избранное',
  'misc.transfer.to_card.info': 'Операция по переводу на карты применяется только к картам Rabita Bank, Kapital Bank, Bank Respublika, Xalq Bank и ABB Bank.',
  'misc.transfer.card': 'Карта',
  'misc.transfer.mpay': 'Mpay кошелек',

  'misc.transfer.confirm': 'Подтвердить платеж',
  'misc.transfer.confirm.wallet-transfer': 'Перевести на кошелек',
  'misc.transfer.confirm.amount': 'Сумма',
  'misc.transfer.confirm.amount.currency': 'AZN',
  'misc.transfer.confirm.commission': 'Комиссия',
  'misc.transfer.confirm.all_amount': 'Общая сумма',
  'misc.transfer.receipt.account': 'Код абонента',
  'misc.transfer.receipt.sender': 'Отправитель',
  'misc.transfer.receipt.receiver': 'Получатель',
  'misc.transfer.receipt.status': 'Статус транзакции',
  'misc.transfer.receipt.date': 'Дата транзакции',
  'misc.transaction.number': 'Номер транзакции',
  'misc.transaction.reversed': 'Сумма возвращена',
  'misc.terminal.inserted': 'Вставлен',
  'misc.terminal.address': 'Адрес',
  'misc.terminal.paid': 'Оплаченный',
  'misc.transfer.receipt.id': 'Номер чека',
  'misc.transfer.receipt.category': 'Услуга',
  'misc.transfer.receipt.type': 'Перевод',
  'misc.transfers.commission.warning': 'К этой сумме будет добавлена комиссия в размере 1% ({commission} AZN).',
  'misc.coupon.receipt.id': 'Номер купона',
  'misc.coupon.receipt.recipient.gift': 'Получатель',
  'misc.coupon.receipt.submitted.date': 'Дата отправки',
  'misc.coupon.receipt.influencer': 'Код инфлюенсера',
  'misc.coupon.receipt.message': 'Пожелания',

  'misc.notify.general.success': 'Операция выполнена успешно!',
  'misc.notify.general.payment_accepted': 'Операция завершена',
  'misc.notify.personal.success': 'Информация успешно обновлена',
  'misc.notify.general.error': 'Произошла ошибка.',
  'misc.notify.general.error.desc': 'Во время операции произошла ошибка. Пожалуйста, попробуйте снова чуть позже.',
  'misc.notify.general.warning': 'Предупреждение',
  'misc.receipt.code.copy': 'Номер квитанции скопирован',
  'misc.notify.bulk.commission.failed': 'По данному платежу может быть рассчитана комиссия',

  'misc.payment.confirm.commission': 'Комиссия MPAY',
  'misc.payment.source': 'Источник платежа',
  'misc.payment.mpay': 'MPAY кошелек:',
  'misc.my_wallet': 'Мой кошелек',
  'misc.second.payment.source': 'Другой источник оплаты',

  'misc.app.bar.userfirstname': 'Имя',
  'misc.app.bar.account': 'Аккаунта',
  'misc.app.search.placeholder': 'Поиск',
  'misc.app.search.not_found': 'Результатов не найдено.',
  'misc.main_page': 'Главная',
  'misc.go.main_page': 'На главную',
  'misc.autopayment.success.desc': 'Автоматический платеж успешно создан!',
  'misc.under_development.header': 'Похоже, пришло время для технического обновления! ',
  'misc.under_development.contetnt': 'Вы скоро вернетесь в мир платежей MPAY 2.0! Вы можете выпить чашку чая и насладиться этим временем ожидания.',
  'misc.under_development.recommend': 'А пока:',
  'misc.under_development.follow.fb': 'Follow us <br/> <b>on Instagram</b> ',
  'misc.under_development.follow.ig': 'Follow us <br/> <b>on Facebook</b>',
  'misc.sima.verified': 'Идентифицированный',
  'misc.sima.not_verified': 'Неидентифицированный',
  'misc.copied': 'Скопировано',
  'misc.sima.verified.with': 'Идентифицируй себя с помощью удостоверения личности',
  'misc.sima.verified.recommend': 'Чтобы увеличить лимит и получить доступ ко всем услугам, подтверди свою личность через <span style="font-weight: 500">мобильное приложение «MPAY».</span>',
  'misc.app.download.qr': 'Чтобы загрузить мобильное приложение «MPAY», отсканируй QR-код.',
  'misc.sima.proceed': 'Перейти',
  'misc.ads.guest.title': 'Mobil tətbiqlə daha rahat 🚀  İndi keçid et!',
  'misc.ads.guest.desc': 'Mobil tətbiqlə ödənişlərin statusundan anında xəbərdar ola, yeni xidmətləri tanıya və yaxınına pul köçürə bilərsən.',
  'misc.ads.guest.guide': 'Telefonun kamerası ilə QR kodu skan edərək keçid et',
  'misc.tour.heading': 'Добро пожаловать в мир MPAY! 🤩',
  'misc.tour.message': 'Откройте для себя наши преимущества и наслаждайтесь удобством платежей!💙',
  'misc.tour.message_1': 'Ты можешь просматривать и изменять уведомления в панели управления.',
  'misc.tour.message_2': 'Ты можешь пополнять баланс кошелька в любое время.',
  'misc.tour.message_3': 'Отсюда ты можешь пополнить кошелек MPAY своего друга.',
  'misc.tour.message_4': 'Ты можешь добавить свои платежи в «Избранное» и завершать их одним кликом.',
  'misc.tour.message_5': 'Перейди в раздел «Автоматические платежи», чтобы автоматизировать свои платежи.',
  'misc.tour.message_6': 'Ты можешь пополнить свой кошелек MPAY или банковскую карту.',
  'misc.tour.next': 'Далее',
  'misc.tour.prev': 'Əvvələ',
  'misc.tour.skip': 'Пропустить',
  'misc.tour.end': 'Закрыть',
  // Sag paneldən ümumi seçilmişlərə baxa bilərsiniz. this text will add above after design finish
};
